import React, { useRef } from "react";
import SignUpContainer from "./signupContainer";
import { Toast } from "primereact/toast";
import Header from "./shared/header";
import { Box, Typography } from "@mui/material";
const AdminUserSignup = () => {
  const toast = useRef(null);
  return (
    <>
      <Toast ref={toast} />
      <Header />
      <Box
        alignItems="center"
        justifyContent="center"
        display="flex"
        margin={"20px"}
      >
        <div className="shadow  Adminsignupcontainer">
          <Typography
            variant="h5"
            fontWeight={"bold"}
            style={{ margin: "20px 0px" }}
          >
            Register User
          </Typography>
          <SignUpContainer throughAdmin={true} />
        </div>
      </Box>
    </>
  );
};

export default AdminUserSignup;
